var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"#919DAF","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.414 10l6.293 6.293-1.414 1.414L.586 9 9.293.293l1.414 1.414L4.414 8H19v2H4.414z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }